import React from 'react';
import { Box, styled, Typography } from '@mui/material';
import { HtmlContent } from '@oh-vcp/components-ui';

const LineFormattedText = styled(Typography)({
  whiteSpace: 'pre-line'
});

const isNarrativeLine = (line: string) => line.startsWith('<');

export const toReportBlocks = (content?: string): string[] =>
  content ? content.split('\n\n').filter((block) => block.trim()) : [];

type EconsultReportBlocksProps = {
  content: string;
  headingLineCount?: number;
  lineSpacing?: number;
  blockSpacing?: number;
  boldNonNarrativeLines?: boolean;
  sectionSpacing?: number;
};

const EconsultReportBlocks: React.FC<EconsultReportBlocksProps> = ({
  content,
  headingLineCount = 0,
  lineSpacing = 0,
  blockSpacing,
  boldNonNarrativeLines = false,
  sectionSpacing
}) => (
  <>
    {toReportBlocks(content).map((block, blockIndex) => {
      const lines = block
        .split('\n')
        .map((line) => line.trim())
        .filter(Boolean);

      return (
        <Box key={`${blockIndex}`} mt={blockIndex === 0 ? 0 : blockSpacing ?? 2 + lineSpacing}>
          {lines.map((line, lineIndex) => {
            if (isNarrativeLine(line)) {
              return (
                <Typography
                  key={`${lineIndex}`}
                  variant="body2"
                  color="base.grey3"
                  component="div"
                  mt={1}>
                  <HtmlContent htmlString={line} component="div" />
                </Typography>
              );
            }

            const startsSection = lineIndex > 0 && isNarrativeLine(lines[lineIndex - 1]);

            return (
              <LineFormattedText
                key={`${lineIndex}`}
                variant="body2"
                color="base.grey3"
                fontWeight={
                  boldNonNarrativeLines || lineIndex < headingLineCount ? 'bold' : undefined
                }
                mt={
                  lineIndex === 0 ? 0 : startsSection ? sectionSpacing ?? lineSpacing : lineSpacing
                }>
                {line}
              </LineFormattedText>
            );
          })}
        </Box>
      );
    })}
  </>
);

export default EconsultReportBlocks;
